interface Replacement {
  regExp: RegExp;
  onMatch: (s: string, match: string, subMatch: string) => string;
}

// const shyString = String.fromCharCode(173);
const zeroWidthSpace = String.fromCharCode(8203);

export const commonReplacements: Replacement[] = [
  // adding space after slashes without leading whitespace #38702
  {
    regExp: /\/([^\s])/,
    onMatch: (s: string, match: string, afterSlash: string) =>
      `/${zeroWidthSpace}${afterSlash}`
  }
];

export const insertHtmlEntities = (
  s: string,
  replacements: Replacement[] = commonReplacements
) =>
  replacements.reduce(
    (s, { regExp, onMatch }) =>
      s.replace(regExp, (match, p, ...args) => onMatch(s, match, p)),
    s
  );
